import React from "react";

import styles from "./ProductInfo.module.scss";
import { Link } from "react-router";
import { IProduct } from "../../../../models/IProduct";
import { API_BASE_URL } from "../../../../config/api";

interface ProductInfoProps {
  product: IProduct;
  allProducts: IProduct[];
}

const shops = [
  { id: 0, category: "Магазин РУНА", output: "Салон  РОСКОШЬ" },
  { id: 1, category: "Магазин TEST", output: "TEST" },
];

const getColorLabel = (name: string) =>
  name.replace("Вискоза STERHANI", "").replace("Вискоза", "").trim() || name;
const toProductPath = (item: IProduct) => `/product/${item.article.toLowerCase()}`;
const toMediaSrc = (url: string) =>
  /^https?:\/\//.test(url) ? url : `${API_BASE_URL}${url.startsWith("/") ? url : `/${url}`}`;

const ProductInfo: React.FC<ProductInfoProps> = ({ product, allProducts }) => {
  const productProps = [
    { id: 0, category: "Тип", output: "Ткань" },
    { id: 1, category: "Состав", output: product.composition || "-" },
    { id: 2, category: "Ширина, см", output: product.width ? String(product.width) : "-" },
    { id: 3, category: "Удельная плотность, г/м²", output: product.density ? String(product.density) : "-" },
    { id: 4, category: "Страна производитель", output: product.country || "-" },
    { id: 5, category: "Артикул", output: product.article },
  ];

  const [isExpanded, setIsExpanded] = React.useState({
    isProductExpanded: false,
    isShopsExpanded: false,
  });
  const [isColorsModalOpen, setIsColorsModalOpen] = React.useState(false);

  const currentColor = getColorLabel(product.name);
  const colors = React.useMemo(() => {
    if (allProducts.length === 0) {
      return [product];
    }
    return allProducts;
  }, [allProducts, product]);

  const visibleColors = colors.slice(0, 8);

  return (
    <div className={styles.productInfo}>
      <h2 className={styles.productTitle}>{product.name}</h2>
      <div className={styles.rating}>
        <div className={styles.star}>
          <svg width="33" height="31" viewBox="0 0 33 31" fill="none">
            <path
              d="M16.4992 25.9702L8.50098 30.7093C8.14764 30.9305 7.77825 31.0252 7.39279 30.9937C7.00734 30.9621 6.67007 30.8357 6.38097 30.6145C6.09188 30.3934 5.86703 30.1172 5.70643 29.7861C5.54582 29.455 5.5137 29.0835 5.61006 28.6715L7.73007 19.7146L0.647326 13.696C0.326113 13.4116 0.125676 13.0875 0.0460153 12.7235C-0.0336455 12.3596 -0.00987587 12.0044 0.117324 11.6582C0.244525 11.3119 0.437252 11.0275 0.695507 10.8051C0.953762 10.5827 1.3071 10.4405 1.75551 10.3786L11.1028 9.57296L14.7164 1.13738C14.8771 0.758255 15.1263 0.473909 15.4642 0.284345C15.8021 0.0947816 16.1471 0 16.4992 0C16.8512 0 17.1962 0.0947816 17.5341 0.284345C17.872 0.473909 18.1213 0.758255 18.2819 1.13738L21.8956 9.57296L31.2428 10.3786C31.6925 10.4418 32.0459 10.584 32.3028 10.8051C32.5598 11.0263 32.7525 11.3106 32.881 11.6582C33.0095 12.0057 33.0339 12.3614 32.9543 12.7254C32.8746 13.0894 32.6735 13.4129 32.351 13.696L25.2683 19.7146L27.3883 28.6715C27.4847 29.0822 27.4525 29.4538 27.2919 29.7861C27.1313 30.1185 26.9065 30.3946 26.6174 30.6145C26.3283 30.8344 25.991 30.9608 25.6056 30.9937C25.2201 31.0265 24.8507 30.9317 24.4974 30.7093L16.4992 25.9702Z"
              fill="#FFC400"
            />
          </svg>
          <p>5.0</p>
        </div>
        <div className={styles.reviews}>
          <div className={styles.divider} />
          <p>5 отзывов</p>
        </div>
      </div>
      <p className={styles.currentColor}>
        Цвет: <span>{currentColor}</span>
      </p>
      <div className={styles.colors}>
        {visibleColors.map((colorProduct) => {
          const imageSrc = toMediaSrc(colorProduct.image_url || "/img/main/temp/e2314e74-484c-4763-8ea0-ba94eecf130c.jpeg");
          const isActive = colorProduct.id === product.id;
          return (
            <Link key={colorProduct.id} className={`${styles.color} ${isActive ? styles.activeColor : ""}`} to={toProductPath(colorProduct)}>
              <img src={imageSrc} alt={getColorLabel(colorProduct.name)} />
            </Link>
          );
        })}
        {colors.length > 8 && (
          <button className={styles.moreColors} onClick={() => setIsColorsModalOpen(true)}>
            Еще
          </button>
        )}
      </div>
      {isColorsModalOpen && (
        <div className={styles.colorsModalOverlay} onClick={() => setIsColorsModalOpen(false)}>
          <div className={styles.colorsModal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.colorsModalHeader}>
              <h3>Все цвета</h3>
              <button onClick={() => setIsColorsModalOpen(false)}>Закрыть</button>
            </div>
            <div className={styles.colorsModalGrid}>
              {colors.map((colorProduct) => {
                const imageSrc = toMediaSrc(colorProduct.image_url || "/img/main/temp/e2314e74-484c-4763-8ea0-ba94eecf130c.jpeg");
                const isActive = colorProduct.id === product.id;
                return (
                  <Link
                    key={colorProduct.id}
                    className={`${styles.color} ${isActive ? styles.activeColor : ""}`}
                    to={toProductPath(colorProduct)}
                    onClick={() => setIsColorsModalOpen(false)}
                  >
                    <img src={imageSrc} alt={getColorLabel(colorProduct.name)} />
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      )}
      <div className={styles.aboutProduct}>
        <div className={styles.row}>
          <h2 className={styles.title}>О товаре:</h2>
          <div className={styles.characteristics}>
            <p>Характеристики</p>
            <svg width="6" height="11" viewBox="0 0 6 11" fill="none">
              <path
                d="M1 1L4.67453 4.70455C5.10849 5.14205 5.10849 5.85795 4.67453 6.29545L1 10"
                stroke="#545454"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        <div className={`${styles.listContainer} ${isExpanded.isProductExpanded ? styles.expanded : ""}`}>
          <ul className={styles.list}>
            {productProps.map((item) => (
              <li key={item.id}>
                <div className={styles.content}>
                  <p className={styles.category}>{item.category}</p>
                  <p className={styles.output}>{item.output}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        {productProps.length > 4 && (
          <div
            className={`${styles.more} ${isExpanded.isProductExpanded ? styles.expanded : ""}`}
            onClick={() => setIsExpanded((prev) => ({ ...prev, isProductExpanded: !prev.isProductExpanded }))}
          >
            <svg width="22" height="9" viewBox="0 0 22 9" fill="none">
              <path
                d="M10.9621 8.46763C10.5946 8.46845 10.2384 8.3699 9.95523 8.1891L0.523569 2.12147C0.220239 1.91148 0.0340992 1.61891 0.00423914 1.30521C-0.0256209 0.9915 0.103122 0.681064 0.363432 0.439091C0.623742 0.197117 0.995367 0.0424311 1.40026 0.00751775C1.80516 -0.0273956 2.21183 0.0601792 2.53487 0.251852L10.9621 5.6896L19.3869 0.446643C19.5477 0.345907 19.7327 0.270688 19.9313 0.225304C20.1299 0.17992 20.3381 0.165264 20.5441 0.182179C20.75 0.199094 20.9496 0.247246 21.1314 0.32387C21.3132 0.400495 21.4735 0.504084 21.6033 0.62869C21.747 0.753585 21.8557 0.900015 21.9227 1.05883C21.9897 1.21764 22.0135 1.38541 21.9927 1.55166C21.9719 1.71791 21.9069 1.87905 21.8018 2.02502C21.6966 2.17099 21.5536 2.29865 21.3817 2.40001L11.95 8.26192C11.659 8.41413 11.3127 8.48656 10.9621 8.46763Z"
                fill="#545454"
              />
            </svg>
          </div>
        )}
        <div className={styles.shops}>
          <div className={styles.allShops}>
            <h2>Наличие в магазинах</h2>
            <Link to="/">Все магазины</Link>
          </div>
          <ul className={`${styles.available} ${isExpanded.isShopsExpanded ? styles.expanded : ""}`}>
            {shops.map((shop) => (
              <li key={shop.id}>
                <p>{shop.category}</p>
                <p>{shop.output}</p>
              </li>
            ))}
          </ul>
          {shops.length > 1 && (
            <div
              className={`${styles.more} ${isExpanded.isShopsExpanded ? styles.expanded : ""}`}
              onClick={() => setIsExpanded((prev) => ({ ...prev, isShopsExpanded: !prev.isShopsExpanded }))}
            >
              <svg width="22" height="9" viewBox="0 0 22 9" fill="none">
                <path
                  d="M10.9621 8.46763C10.5946 8.46845 10.2384 8.3699 9.95523 8.1891L0.523569 2.12147C0.220239 1.91148 0.0340992 1.61891 0.00423914 1.30521C-0.0256209 0.9915 0.103122 0.681064 0.363432 0.439091C0.623742 0.197117 0.995367 0.0424311 1.40026 0.00751775C1.80516 -0.0273956 2.21183 0.0601792 2.53487 0.251852L10.9621 5.6896L19.3869 0.446643C19.5477 0.345907 19.7327 0.270688 19.9313 0.225304C20.1299 0.17992 20.3381 0.165264 20.5441 0.182179C20.75 0.199094 20.9496 0.247246 21.1314 0.32387C21.3132 0.400495 21.4735 0.504084 21.6033 0.62869C21.747 0.753585 21.8557 0.900015 21.9227 1.05883C21.9897 1.21764 22.0135 1.38541 21.9927 1.55166C21.9719 1.71791 21.9069 1.87905 21.8018 2.02502C21.6966 2.17099 21.5536 2.29865 21.3817 2.40001L11.95 8.26192C11.659 8.41413 11.3127 8.48656 10.9621 8.46763Z"
                  fill="#545454"
                />
              </svg>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductInfo;
